<template>
  <div class="blocked_logs_page">
    <h1>匹配通话时长分布</h1>
    <div class="user-options clearfix">
      <el-select
        style="width: 160px"
        v-model="curChannel.selectValue"
        placeholder
      >
        <el-option
          v-for="(item, itemIndex) in channels"
          v-bind:key="itemIndex"
          :label="item.label"
          :value="item.value"
        ></el-option>
      </el-select>
      <el-select
        style="width: 160px"
        v-model="language"
        placeholder
      >
        <el-option
            v-for="(item, itemIndex) in languageList"
            v-bind:key="itemIndex + 199"
            :label="item.language"
            :value="item.langCode"
          ></el-option>
      </el-select>
       <el-select
        style="width: 160px"
        v-model="country"
        placeholder
      >
        <el-option
            v-for="(item, itemIndex) in countryList"
            v-bind:key="itemIndex + 99"
            :label="item.country"
            :value="item.countryCode"
          ></el-option>
      </el-select>
      <el-select
        style="width: 160px"
        v-model="userType"
        placeholder
      >
        <el-option
            v-for="(item, itemIndex) in userTypes"
            v-bind:key="itemIndex + 99"
            :label="item.label"
            :value="item.value"
          ></el-option>
      </el-select>
    </div>
    <div class="user-options clearfix">
      <el-select
        style="width: 160px"
        v-model="searchType"
        placeholder
      >
        <el-option
            v-for="(item, itemIndex) in searchTypes"
            v-bind:key="itemIndex + 99"
            :label="item.label"
            :value="item.value"
          ></el-option>
      </el-select>
     
      <el-date-picker
          v-model="platformData"
          type="daterange"
          align="right"
          unlink-panels
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          :picker-options="retainedOptions"
          value-format="yyyy-MM-dd"
        >
        </el-date-picker>
      <el-button type="primary" @click="get_list" :loading="login1">查询</el-button>
      <!-- <el-button type="primary" @click="dwnDayChatDetai">下载</el-button> -->
    </div>
    <CustomBar 
        element-loading-text="拼命加载中"
				element-loading-spinner="el-icon-loading"
				v-loading="login1"
				:options="barOptions"
				class="bar"
				width="100%"></CustomBar>
      <!-- <el-row >
      <el-pagination
        :current-page.sync="page"
        layout="total, prev, pager, next"
        background
        @current-change="handleCurrentChange"
        :total="total"
        :page-size="30"
      ></el-pagination>
    </el-row> -->
  </div>
</template>

<script>
import CustomBar from '@/components/CustomBar'
import download from '@/utils/download.js'
import { datainfor } from '@/utils/formdata.js'
import { getCountry, getLanguage } from '@/utils/normalApi.js'
export default {
  components: {
    CustomBar
  },
  data() {
    return {
      login1: false,
      curChannel: {
        selectValue: 'total',
        content: ''
      },
      barOptions: {
        xAxis: {
          name: '时间',
          type: 'category',
          data: ['<30s', '30-60s', '60-120s', '120-180s', '180-300s','300-600s','600-1200s','>1200s']
        },
        yAxis: {
          name: '人数',
          type: 'value'
        },
        series: [
          {
            data: [],
            type: 'bar',
            itemStyle: {
              normal: {
                label: {
                  show: true, //开启显示
                  position: 'top', //在上方显示
                  textStyle: {
                    //数值样式
                    color: 'black',
                    fontSize: 16
                  }
                }
              }
            }
          }
        ]
      },
      channels: this.$store.state.channels,
      platformData: [datainfor(2), datainfor(1)],
      retainedOptions: {
        disabledDate(time) {
          return time.getTime() > Date.now()
        }
      },
      tableList: [],
      loading: true,
      language: 'total',
      languageList: '',
      country: 'total',
      countryList: '',
      searchType: 1,
      searchTypes: [
        {
          label: '次数',
          value: 1
        },
        {
          label: '人数',
          value: 0
        }
      ],
      userType: -1,
      userTypes: [
        {
          label: 'total',
          value: -1
        },
        {
          label: '新用户',
          value: 1
        },
        {
          label: '老用户',
          value: 0
        }
      ],
      page: 1,
      total: 0
    }
  },
  beforeCreate() {},
  created() {
    this.languages()
    this.getCountry_()
    this.get_list()
  },
  mounted() {},
  computed: {
    username() {
      return this.$store.getters.username
    },
    userLevel() {
      return this.$store.getters.userLevel
    },
    token() {
      return this.$store.getters.token
    }
  },
  watch: {},
  methods: {
    async languages() {
      const res = await getLanguage()
      if (res !== null) {
        this.languageList = res
      }
    },
    async getCountry_() {
      const res = await getCountry()
      if (res !== null) {
        this.countryList = res.countryList
      }
    },
    async get_list() {
      this.login1 = true
      const { data: res } = await this.$axios({
        method: 'get',
        url: this.$store.getters.path.user_match_realCallDuration,
        withCredentials: true,
        params: {
          username: this.$store.getters.username,
          token: this.$store.getters.token,
          start: this.platformData[0],
          end: this.platformData[1],
          channel: this.curChannel.selectValue,
          country: this.country,
          language: this.language,
          userType: this.userType,
          searchType:this.searchType
        }
      })
      if (res !== null) {
        this.login1 = false
        this.total = res.data.total
        if (this.searchType == 1) {
          this.barOptions.yAxis.name = '次数'
        } else {
          this.barOptions.yAxis.name = '人数'
        }
        this.barOptions.series[0].data = []
        this.barOptions.series[0].data.push(res.data.data.lt30s)  
        this.barOptions.series[0].data.push(res.data.data.gte30sTo60s)  
        this.barOptions.series[0].data.push(res.data.data.gte60sTo120s)  
        this.barOptions.series[0].data.push(res.data.data.gte120sTo180s)  
        this.barOptions.series[0].data.push(res.data.data.gte180sTo300s)  
        this.barOptions.series[0].data.push(res.data.data.gte300sTo600s)  
        this.barOptions.series[0].data.push(res.data.data.gte600sTo1200s)  
        this.barOptions.series[0].data.push(res.data.data.gte1200s)  
        
      }
    },
    // 分页
    handleCurrentChange(num) {
      this.page = num
      this.get_list()
    },
    // 下载
    async dwnDayChatDetai() {
      this.login2 = true
      const res = await this.$axios({
        method: 'get',
        url: this.$store.getters.path.user_match_action_download,
        withCredentials: true,
        headers: {
          'Content-Type': 'application/json'
        },
        responseType: 'blob',
        params: {
          username: this.$store.getters.username,
          token: this.$store.getters.token,
          start: this.platformData[0],
          end: this.platformData[1],
          channel: this.curChannel.selectValue,
          country: this.country,
          language: this.language,
          userType: this.userType
        }
      })

      this.$message.success('开始下载')
      this.login2 = false
      download(
        res.data,
        '匹配行为数据' + (this.platformData[0] + '-' + this.platformData[1])
      )
    }
  }
}
</script>


<style lang="scss" scoped>
.blocked_logs_page {
  margin-left: 20px;
  margin-top: 20px;

  h1 {
    font-size: 28px;
    font-weight: bold;
  }

  .user-options {
    margin-top: 40px;

    button {
      margin-left: 30px;
    }
  }

  .display-type {
    margin-top: 20px;
  }
}
</style>
